import { notification } from '@/workspace/components/notification'
import Axios, { type InternalAxiosRequestConfig } from 'axios'
import * as Cookie from 'js-cookie'

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  if (config.headers) {
    config.headers.Accept = 'application/json'
    config.headers['X-XSRF-TOKEN'] = Cookie.get('XSRF-TOKEN')

    const authToken = JSON.parse(localStorage.getItem('authToken') || '{}')
    config.headers.Authorization = `Bearer ${authToken.access_token}`
  }

  config.withCredentials = true
  return config
}

export const api = Axios.create({
  baseURL: '/api/',
})

api.interceptors.request.use(authRequestInterceptor)
api.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    const message = error.response?.data?.message || error.message

    if (error.response?.status === 401 || error.response?.status === 403) {
      window.location.href = '/login'
    }

    notification.error({
      message: 'エラーが発生しました',
      description: message,
    })

    return Promise.reject(error)
  },
)

export const loginApi = Axios.create({
  baseURL: '/',
})

loginApi.interceptors.request.use(authRequestInterceptor)
loginApi.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    const messages: { [key: string]: string[] } = error.response?.data?.errors
    if (messages) {
      notification.error({
        message: '情報が正しくありません',
        description: Object.values(messages).join('\n'),
      })
    } else {
      notification.error({
        message: 'ログインに失敗しました',
        description: 'メールアドレスまたはパスワードが正しくありません',
      })
    }

    return Promise.reject(error)
  },
)

export const downloadApi = Axios.create({
  baseURL: '/api/',
})

downloadApi.interceptors.request.use(authRequestInterceptor)
downloadApi.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const message = error.response?.data?.message || error.message
    notification.error({
      message: 'エラーが発生しました',
      description: message,
    })

    if (error.response?.status === 401 || error.response?.status === 403) {
      window.location.href = '/login'
    }

    return Promise.reject(error)
  },
)

export const userApi = Axios.create({
  baseURL: '/api/',
})

userApi.interceptors.request.use(authRequestInterceptor)
userApi.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    return Promise.reject(error)
  },
)
